import Link from '@platform-ui-common/components/Link/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';

const TaxFormDescription = (): JSX.Element => {
  return (
    <>
      <Typography variant="largeBody" alignment="center">
        We will use the information provided on this page to help generate a 1099 to make tax time
        easier for you. For information about W9s, go to{' '}
        <Link
          external
          target="_blank"
          variant="largeBody"
          to={'https://www.irs.gov/forms-pubs/about-form-w-9'}
          bold={false}
        >
          irs.gov
        </Link>
        .
      </Typography>
      <div className="mt-6">
        <Typography variant="body">* An asterisk indicates a required response</Typography>
      </div>
    </>
  );
};

export default TaxFormDescription;
